import {useQuery} from '@tanstack/react-query'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {doCustomAPICall} from '../utils/custom-api-utils'

/**
 * Get Content Aset with useQuery
 */
export const useContentAsset = (ids = [], isMenu = false) => {
    const {getTokenWhenReady} = useAccessToken()
    const config = getConfig()
    const appOrigin = useAppOrigin()
    const customAPIFolderName = 'content-assets'
    const contentAssets = Array.isArray(ids)
        ? ids.filter((id) => typeof id === 'string' && id.trim() !== '')
        : typeof ids?.id === 'string'
        ? [ids?.id].filter((id) => typeof id === 'string' && id.trim() !== '')
        : []

    const apiPath = `content-asset?c_asset_id=${contentAssets.join(',')}&c_isMenu=${isMenu}&`

    const {data} = useQuery({
        queryKey: ['custom', 'content-assets', contentAssets],
        queryFn: () =>
            doCustomAPICall(getTokenWhenReady, {
                config,
                appOrigin,
                customAPIFolderName,
                apiPath
            }),
        enabled: contentAssets.length > 0,
        staleTime: 5 * 60000,
        cacheTime: 30 * 60000
    })

    return data?.content
}
